import React from "react";

export function Portal() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M23.5971 11.8138L19.9598 8.17649V3.97478C19.9598 3.21505 19.3442 2.59935 18.5833 2.59935C17.8242 2.59935 17.2086 3.21505 17.2086 3.97478V5.42529L14.5003 2.71693C13.1613 1.37866 10.8333 1.38103 9.49731 2.71935L0.402658 11.8138C-0.134219 12.3517 -0.134219 13.2222 0.402658 13.7593C0.939778 14.2971 1.8119 14.2971 2.34883 13.7593L11.4426 4.6646C11.7389 4.3699 12.261 4.3699 12.5557 4.66372L21.651 13.7593C21.9207 14.0282 22.2723 14.162 22.6239 14.162C22.9761 14.162 23.3283 14.0281 23.5972 13.7593C24.1343 13.2222 24.1343 12.3518 23.5971 11.8138Z"
          fill="#3C4E64"
        />
        <path
          d="M12.4778 7.27567C12.2136 7.01159 11.7857 7.01159 11.5223 7.27567L3.52261 15.273C3.39631 15.3992 3.32471 15.5716 3.32471 15.7515V21.5844C3.32471 22.9531 4.43451 24.0629 5.8032 24.0629H9.76385V17.9292H14.2354V24.0629H18.196C19.5647 24.0629 20.6745 22.9531 20.6745 21.5844V15.7515C20.6745 15.5716 20.6035 15.3992 20.4766 15.273L12.4778 7.27567Z"
          fill="#3C4E64"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
